export default "__VITE_ASSET__C9$NkN_t__"